import classnames from 'classnames';
import React, { FC } from 'react';
import { GenericLayout } from '../Generic';
import { ILayout } from '../types';
import { GalleryFile } from './GalleryFile';
import { GalleryFolder } from './GalleryFolder';
import styles from './GalleryLayout.scss';
import { GalleryLoadingIndicator } from './GalleryLoadingIndicator';

export const GalleryLayout: FC<ILayout> = ({
  className,
  isLoading,
  hasMoreItems,
  dataHook = 'gallery-layout',
  children,
  onClick,
  onContextMenu,
  loadMoreItems,
  resetFilesStream,
  itemsCount,
  extendedFiltersElement,
  itemsClassName,
  selectItem,
  searchQuery,
}) => (
  <GenericLayout
    className={className}
    itemsClassName={classnames(styles.items, itemsClassName)}
    isLoading={isLoading}
    hasMoreItems={hasMoreItems}
    onClick={onClick}
    onContextMenu={onContextMenu}
    loadMoreItems={loadMoreItems}
    dataHook={dataHook}
    resetFilesStream={resetFilesStream}
    itemsCount={itemsCount}
    extendedFiltersElement={extendedFiltersElement}
    selectItem={selectItem}
    searchQuery={searchQuery}
  >
    {children({
      File: GalleryFile,
      Folder: GalleryFolder,
      LoadingIndicator: GalleryLoadingIndicator,
      itemClassName: styles.item,
    })}
  </GenericLayout>
);
